module.exports = __webpack_public_path__ + "media/brandVideo.c74a02ff.mp4";